import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Check, AlertTriangle, Loader } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: "pending", message: "" });

  useEffect(() => {
    async function run() {
      if (!token) {
        setState({ status: "error", message: "No verification token in link." });
        return;
      }
      try {
        const { data } = await api.post("/auth/verify", { token });
        setState({ status: "success", message: data.already_verified ? "Already verified." : "Email verified." });
        // Refresh auth context so the banner disappears immediately
        if (refreshUser) await refreshUser();
      } catch (err) {
        setState({ status: "error", message: err?.response?.data?.detail || "Verification failed." });
      }
    }
    run();
  }, [token, refreshUser]);

  const icon = state.status === "pending" ? <Loader className="animate-spin" size={28} /> : state.status === "success" ? <Check size={28} /> : <AlertTriangle size={28} />;
  const tint = state.status === "success" ? "text-[#3B82F6]" : state.status === "error" ? "text-red-400" : "text-[#A3A3A3]";

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-8" data-testid="verify-email-page">
      <div className="max-w-md w-full border border-[#262626] rounded-md p-10 bg-[#141414]">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#737373] mb-4">EMAIL VERIFICATION</div>
        <div className={`${tint} mb-4`}>{icon}</div>
        <h1 className="font-[Outfit] text-3xl font-semibold tracking-tight">
          {state.status === "pending" ? "Verifying…" : state.status === "success" ? "You're verified." : "Verification failed"}
        </h1>
        <p className="text-[#A3A3A3] mt-3 text-sm leading-relaxed" data-testid="verify-email-message">{state.message}</p>
        <div className="mt-8 flex gap-3">
          <Link to="/dashboard" className="inline-flex items-center gap-2 bg-white text-black px-5 py-3 text-sm font-semibold rounded-md hover:bg-[#A3A3A3] transition-colors" data-testid="verify-email-home-link">
            Go to dashboard
          </Link>
          <Link to="/login" className="inline-flex items-center gap-2 border border-[#262626] text-[#A3A3A3] hover:text-white hover:border-white px-5 py-3 text-sm rounded-md transition-colors">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
